import { nifsAxios } from '../../constants/axios';

interface PingResponse {
  serverDate: string;
  offsetSeconds: number;
}

interface GetPingResponse {
  data: PingResponse;
  responseTime: number;
}

export default async function (): Promise<GetPingResponse> {
  const start = Date.now();
  try {
    const response = await nifsAxios.get('/ping/', {
      timeout: 10000,
    });
    const finish = Date.now();
    return { data: response.data, responseTime: finish - start };
  } catch {
    return { data: { serverDate: '', offsetSeconds: 0 }, responseTime: 10000 };
  }
}
